import Script from 'next/script';
import React from 'react';

declare global {
  interface Window {
    CoveoSearchPage: {
      initialize: (apiKey: string) => void;
    };
  }
}

const CoveoSimpleSearch: React.FC = () => {
  const [scriptLoaded, setScriptLoaded] = React.useState(false);

  const apiKey = process.env['NEXT_PUBLIC_COVEO_API_KEY'];
  const scriptUrl = process.env['NEXT_PUBLIC_COVEO_SCRIPT_URL'];

  React.useEffect(() => {
    let observer: MutationObserver | null = null;
    if (apiKey && scriptLoaded) {
      // Initialize the Coveo search page
      window?.CoveoSearchPage.initialize(apiKey);

      observer = new MutationObserver(() => {
        const coveoSearchPage = document.getElementsByTagName('coveo-search-page')[0];
        const shadowRoot = coveoSearchPage?.shadowRoot;
        const searchBoxElement = shadowRoot?.querySelector('atomic-search-box');

        searchBoxElement?.setAttribute('minimum-query-length', '1');
        observer?.disconnect();
      }); // Observe changes in the DOM for the 'coveo-search-page' and its children

      observer.observe(document.body, { childList: true, subtree: true }); // Cleanup observer when the component unmounts
    }
    return () => observer?.disconnect();
  }, [apiKey, scriptLoaded]);

  const handleScriptLoad = () => {
    if (!scriptLoaded) {
      setScriptLoaded(true);
    }
  };

  return scriptUrl ? <Script async={true} onLoad={handleScriptLoad} src={scriptUrl}></Script> : null;
};

export default CoveoSimpleSearch;
